import axios from "axios";
import router from "../../../router/router";

export default {
  state: {
    campaignsData: [],
  },
  mutations: {
    campaignsInfo(state, payload) {
      state.campaignsData = payload;
    },
  },
  getters: {
    getCampaignsData(state) {
      return state.campaignsData;
    },
    // step(state) {
    //     return state.step;
    // },
  },
  actions: {
    async getCampaigns(context, page) {
      const pageNumber = page || 1;
      let token = localStorage.getItem("token");
      let country_code = localStorage.getItem("country_code")
      let response = await axios.get(
        `https://publish.dkilo.com/api/campaigns?page=${pageNumber}`,
        {
          headers: { token: token ,"Country-Code": country_code},
        }
      );

      context.commit("campaignsInfo", response.data.campaigns);
    },
  },
};
